<template>
  <div>
    <b-row>
      <b-col>
        <header-view
          :title="$t('message.adminUserList.title')"
          icon="ti-receipt">
        </header-view>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <b-card class="rounded-0">
          <b-form-input
            class="rounded-0 ml-auto w-25"
            placeholder="Filter"
            v-model="filterValue"
            @blur.native="getFilteredUsers(filterValue)"/>
          <b-table
            striped
            hover
            responsive
            class="mt-4 admin-user-table"
            tbody-tr-class="admin-user-table"
            :current-page="currentPage"
            :per-page="perPage"
            :fields="fields"
            :items="getFilteredUsers(filterValue)"
            @row-hovered=""
            @row-clicked="showDetails">
            <template slot="roles" slot-scope="data">
              <div v-for="role in translatedRoles(data.item.roles)">
                {{ role }}
              </div>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          class="my-0 rounded-0"
          :total-rows="getFilteredUsers(filterValue).length"
          :per-page="perPage"
        />
      </b-col>
      <b-col md="6" class="my-1 text-right">
        <b-form-group
          horizontal
          :label="$t('message.adminUserList.perPage')"
          :label-cols="9">
          <b-form-select
            class="rounded-0"
            v-model="perPage"
            :options="pageOptions"/>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import HeaderView from '@/components/common/HeaderView'
  import utils from '@/utils'

  export default {
    name: 'AdminUserList',
    components: {
      HeaderView
    },
    computed: {
      users () {
        return this.$store.getters.adminUserList
      }
    },
    created () {
      this.$store.dispatch('fetchUserList', true)
    },
    data () {
      return {
        currentPage: 1,
        fields: [{
          key: 'id',
          label: this.$t('message.adminUserList.table.id')
        }, {
          key: 'firstName',
          label: this.$t('message.adminUserList.table.firstName')
        }, {
          key: 'lastName',
          label: this.$t('message.adminUserList.table.lastName')
        }, {
          key: 'email',
          label: this.$t('message.adminUserList.table.email')
        }, {
          key: 'dateOfBirth',
          label: this.$t('message.adminUserList.table.dateOfBirth'),
          formatter: (value) => {
            return this.$moment(value).format('DD.MM.YYYY')
          }
        }, {
          key: 'roles',
          label: this.$t('message.adminUserList.table.roles')
        }, {
          key: 'contractNumber',
          label: this.$t('message.adminUserList.table.contractNumber')
        }, {
          key: 'isCertificateOfDeathApproved',
          label: this.$t('message.adminUserList.table.status'),
          formatter: (value) => {
            if (value) {
              return this.$t('message.adminUserList.status.death')
            }
            return this.$t('message.adminUserList.status.alive')
          }
        }, {
          key: 'createdAt',
          label: this.$t('message.adminUserList.table.registration'),
          formatter: (value) => {
            return this.$moment(value).format('DD.MM.YYYY')
          }
        }, {
          key: 'isAuthorized',
          label: this.$t('message.adminUserList.table.legitimation'),
          formatter: (value) => {
            if (!value) {
              return this.$t('message.adminUserList.isNotAuthorized')
            }
            return this.$t('message.adminUserList.isAuthorized')
          }
        }],
        filterValue: null,
        pageOptions: [20, 50, 100],
        perPage: 20
      }
    },
    methods: {
      getFilteredUsers (value) {
        const filtered = this.users.filter(user => {
          if (!value) {
            return true
          }
          const formattedDateOfBirth = this.$moment(user.dateOfBirth).format('DD.MM.YYYY')
          const translatedRoles = user.roles.filter(role => this.$t('enums.roles.' + role.roleOfUser).toLowerCase().includes(value.toLowerCase()))
          const deathValue = this.$t('message.adminUserList.status.death').toLowerCase()
          const aliveValue = this.$t('message.adminUserList.status.alive').toLowerCase()
          const formattedDateOfRegistration = this.$moment(user.createdAt).format('DD.MM.YYYY')
          const isAuthorizedValue = this.$t('message.adminUserList.isAuthorized').toLowerCase()
          const isNotAuthorizedValue = this.$t('message.adminUserList.isNotAuthorized').toLowerCase()

          if (user.id.toString().includes(value.toLowerCase())) {
            return user
          } else if (user.firstName && user.firstName.toLowerCase().includes(value.toLowerCase())) {
            return user
          } else if (user.lastName && user.lastName.toLowerCase().includes(value.toLowerCase())) {
            return user
          } else if (user.email && user.email.toLowerCase().includes(value.toLowerCase())) {
            return user
          } else if (formattedDateOfBirth.toString().includes(value.toLowerCase())) {
            return true
          } else if (translatedRoles.length > 0) {
            return true
          } else if (user.contractNumber && user.contractNumber.toString().includes(value.toLowerCase())) {
            return true
          } else if (user.isCertificateOfDeathApproved && deathValue.includes(value.toLowerCase())) {
            return true
          } else if (!user.isCertificateOfDeathApproved && aliveValue.includes(value.toLowerCase())) {
            return true
          } else if (formattedDateOfRegistration.toString().includes(value.toLowerCase())) {
            return true
          } else if (user.isAuthorized && isAuthorizedValue.includes(value.toLowerCase())) {
            return true
          } else if (!user.isAuthorized && isNotAuthorizedValue.includes(value.toLowerCase())) {
            return true
          }
        })
        return filtered
      },
      translatedRoles (roles) {
        return utils.getTranslatedRoles(this, roles)
      },
      showDetails (item) {
        this.$router.push('/admin/users/' + item.id)
      }
    }
  }
</script>
<style scoped>
  .admin-user-table:hover {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminUserList.vue